import * as React from 'react';
export const automationSvg = React.forwardRef(function automationSvgInner(
  props,
  ref,
) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      d: 'M5.82 7.983c.47 0 .85.38.85.85v1.333a.85.85 0 1 1-1.7 0V8.833c0-.47.381-.85.85-.85Zm4.344 0c.47 0 .85.38.85.85v1.333a.85.85 0 1 1-1.7 0V8.833c0-.47.38-.85.85-.85Z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M8 0a2.25 2.25 0 0 1 2.25 2.25V3h1.25a3 3 0 0 1 3 3v2.75h.753a.75.75 0 0 1 0 1.5H14.5V13a3 3 0 0 1-2.846 2.996L11.5 16h-7l-.154-.004a3 3 0 0 1-2.842-2.842L1.5 13v-2.75H.75a.75.75 0 0 1 0-1.5h.75V6a3 3 0 0 1 3-3h1.25v-.75A2.25 2.25 0 0 1 8 0ZM4.5 4.5A1.5 1.5 0 0 0 3 6v7a1.5 1.5 0 0 0 1.5 1.5h7A1.5 1.5 0 0 0 13 13V6a1.5 1.5 0 0 0-1.5-1.5h-7Zm3.5-3a.75.75 0 0 0-.75.75V3h1.5v-.75A.75.75 0 0 0 8 1.5Z',
    }),
  );
});
automationSvg.defaultProps = {
  width: '16',
  height: '16',
  viewBox: '0 0 16 16',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var automation = {
  category: 'icon',
  colorable: true,
  name: 'automation',
  svg: automationSvg,
};
